import { PageTitle } from "@/components/ui/PageTitle";
import { TagDialog } from "@/components/ui/tags/TagDialog";
import { Pages } from "@/pages/Pages";
import { QueryClientProvider } from "@/queries/QueryClientProvider";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { createTheme, CssBaseline, darken, ThemeProvider } from "@mui/material";
import { grey } from "@mui/material/colors";
import { BrowserRouter } from "react-router";
import { AppBar } from "./AppBar";
import { Sidebar } from "./Sidebar";

const theme = createTheme({
  colorSchemes: {
    dark: {
      palette: {
        background: {
          paper: darken(grey[900], 0.2),
        },
        text: {
          primary: grey[200],
        },
      },
    },
  },
  typography: {
    fontSize: 12.25,
  },
  palette: {
    background: {
      paper: grey[100],
    },
  },
});

export function App() {
  return (
    <QueryClientProvider>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline enableColorScheme/>
          <PageTitle />
          <AppBar />
          <Sidebar />
          <Pages />
          <TagDialog />
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
